import fp from 'lodash/fp';
import { withStateHandlers } from 'recompose';

const withState = (initialState) =>
  withStateHandlers(initialState,
    fp.flow(
      fp.keys,
      fp.map((key) =>
        [
          `set${fp.upperFirst(key)}`,
          (state, props) =>
            (value) => ({
              [key]: typeof (value) === 'function' ?
                value(state, props) :
                value
            })
        ]
      ),
      fp.fromPairs
    )(initialState)
  );

export default withState;



// WEBPACK FOOTER //
// ./src/components/higher-order/with-state.js